
export interface IBookingInfoContent {
    storyId: number;
    instructions: string;
    token: string;
    unlockCodes: string[];
}

export enum EOTA {
    manual = -1,
    viator = 1,
    getyourguide = 2,
    tripadvisor = 3,
    eventbrite = 4,
    tripcom = 6,
    website = 10,
    shopify = 11
}

export enum EProviderPrefix {
    OTA = 100,
    integration = 200
}